import React from "react";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";

interface Props {
  packagingToday: { totalUnits: number; totalWeight: number };
  productionToday: { manufacturedWeight: number; targetWeight: number };
  loading: boolean;
  onRetry?: () => void;
}

const fmt = (n: number) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(n);

const StatCard: React.FC<{
  label: string;
  value: string | number;
  loading: boolean;
}> = ({ label, value, loading }) => {
  return (
    <div className="p-4 bg-white rounded-xl shadow flex flex-col">
      <div className="text-xs font-medium text-gray-500">{label}</div>
      <div className="mt-2 text-2xl font-semibold text-gray-900">
        {loading ? <Skeleton width="6rem" height="1.5rem" /> : value}
      </div>
      <div className="mt-1 text-xs text-gray-400">Today</div>
    </div>
  );
};

const PackagingProductionStatsBar: React.FC<Props> = ({
  packagingToday,
  productionToday,
  loading,
  onRetry,
}) => {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
      <StatCard
        label="Packaged Units"
        loading={loading}
        value={loading ? "" : packagingToday.totalUnits}
      />
      <StatCard
        label="Packaged Weight "
        loading={loading}
        value={loading ? "" : `${packagingToday.totalWeight} `}
      />
      <StatCard
        label="Manufactured Weight "
        loading={loading}
        value={loading ? "" : `${productionToday.manufacturedWeight} `}
      />

      <StatCard
        label="Manufactured Target Weight "
        loading={loading}
        value={loading ? "" : `${productionToday.targetWeight} `}
      />
    </div>
  );
};

export default PackagingProductionStatsBar;
